// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
export const HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';

export const isHello: (cloudId?: string) => cloudId is "a436116f-02ce-4520-8fbb-7301462a1674" = (cloudId?: string) => cloudId === HELLO_TENANT_ID;
